module.exports = __webpack_public_path__ + "img/share.257480bb.svg";